
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/money3",
      function () {
        return require("private-next-pages/brands/money3.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/money3"])
      });
    }
  